module.exports = __webpack_public_path__ + "6b68877aac7b9aa6b74f4180513a05bf.jpg";